<h1 id="tableLabel">Blackboxes</h1>

<p>This component demonstrates fetching data from the server.</p>

<p *ngIf="!blackBoxes"><em>Loading...</em></p>

<table class='table table-striped' aria-labelledby="tableLabel" *ngIf="blackBoxes">
  <thead>
    <tr>
      <th>Imei Number</th>
      <th>Vehicle Registration</th>
      <th>customerDescription</th>
      <th>isActive</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let blackbox of blackBoxes">
      <td>{{ blackbox.imeiNumber }}</td>
      <td>{{ blackbox.vehicleRegistration }}</td>
      <td>{{ blackbox.customerDescription }}</td>
      <td>{{ blackbox.isActive }}</td>
    </tr>
  </tbody>
</table>
